import React from 'react';

/** Playlist sub-view for AlbumDetailView's header ⋮ menu — add all album tracks or create a new playlist. */
export default function AlbumMenuPlaylistPanel({ playlists, newName, onNewNameChange, onCreate, onAddToPlaylist, onBack }) {
  const itemStyle = { color: '#1a1a2e' };
  const hover = (e) => { e.currentTarget.style.background = 'rgba(0,0,0,0.05)'; };
  const unhover = (e) => { e.currentTarget.style.background = 'transparent'; };

  return (
    <div data-testid="album-menu-playlist-view">
      <button
        onClick={onBack}
        className="w-full px-4 py-2.5 text-left text-xs font-semibold"
        style={{ color: '#666', borderBottom: '1px solid rgba(0,0,0,0.08)' }}
      >
        ← Add to Playlist
      </button>
      <div style={{ padding: '8px 12px', display: 'flex', gap: 6 }}>
        <input
          type="text"
          value={newName}
          onChange={(e) => onNewNameChange(e.target.value)}
          placeholder="New playlist…"
          className="flex-1 text-sm"
          style={{ padding: '6px 8px', borderRadius: 6, border: '1px solid rgba(0,0,0,0.15)', color: '#1a1a2e' }}
          onKeyDown={async (e) => {
            if (e.key === 'Enter' && newName.trim()) {
              const n = newName.trim();
              onNewNameChange('');
              try { await onCreate(n); } catch { /* surfaced via toast */ }
            }
          }}
        />
      </div>
      {playlists.length === 0 && (
        <div className="px-4 py-2 text-xs" style={{ color: '#999' }}>No playlists yet</div>
      )}
      {playlists.map((pl) => (
        <button
          key={pl.id}
          onClick={() => onAddToPlaylist(pl.id)}
          className="w-full flex items-center gap-2.5 px-4 py-2.5 text-left text-sm transition"
          style={itemStyle}
          onMouseEnter={hover}
          onMouseLeave={unhover}
        >
          {pl.name}
        </button>
      ))}
    </div>
  );
}
